import { useSearchParams } from "react-router-dom";

const useQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const setQueryParams = (params: Record<string, string>) => {
    const newParams = new URLSearchParams(searchParams);

    for (const key in params) {
      const value = params[key];
      if (value === "") {
        newParams.delete(key);
      } else {
        newParams.set(key, value);
      }
    }

    setSearchParams(newParams);
  };

  const paramsObject = Object.fromEntries(searchParams.entries());

  return {
    paramsObject,
    searchParams,
    setQueryParams,
  };
};

export default useQueryParams;
